module.exports = __webpack_public_path__ + "img/yangyuanyou_20210901114610.586fffa2.png";